import React, {useEffect} from "react";
import {useParams} from "react-router";

const About = ()=> {
  const params=useParams();

  const href= window.location.href;
  const hToken=localStorage.getItem('hToken');
  const headers=hToken &&  new Headers();

  const ar = Array(10).fill(1);
  useEffect(()=>{



  },[])
  return (
    <div className='flex-grow  p-2' >
<h1  className=' my-4 display-4'>About</h1>
      <div>Highly creative and detail-oriented visual communications expert with a strong foundation in art and design. Leveraging a unique blend of technical and creative skills to develop innovative solutions and create visually appealing user experiences.
        Strong ability to communicate technical concepts to non-technical stakeholders.<br/>

        Keen interest in staying updated with the latest design and coding trends:<br/>
        User Interface (UI) Design<br/>
        Human-Computer Interaction (HCI)<br/>
        Digital Art and Design<br/>
        2D and 3D Modeling<br/>
        Color Theory<br/>
        Visual Communication<br/>
        Typography</div>
    </div>
  );
}

export default About;
